import { mapKeys, omit } from 'lodash';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import skillookAdmin from 'apis/skillookAdmin';

// First, create the thunk
export const allReportedUserListRequest = createAsyncThunk(
  'allReportedUserList',
  async limitArr => {
    const [start, limit, filter] = limitArr;
    const response = await skillookAdmin.get(
      `admin/users/reported/users?skip=${start}&limit=${limit}&searchType=${filter}`
    );
    return response.data.data;
  }
);

// Delete Reported User

export const deleteReportUserRequest = createAsyncThunk(
  'deleteReportUser',
  async payload => {
    await skillookAdmin.delete('admin/users/delete', { data: payload });
    return payload.userID;
  }
);

// Then, handle actions in your reducers:
const allReportedUserListSlice = createSlice({
  name: 'allReportedUserList',
  initialState: { list: {}, totalUsers: 0, refreshPage: false },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    emptyAllReportedUserList() {
      return {};
    },
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [allReportedUserListRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list: { ...mapKeys(action.payload.reportedCandidates, '_id') },
        totalUsers: action.payload.totalReportedCount,
        refreshPage: false,
      };
    },
    [deleteReportUserRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list: omit(state.list, action.payload),
        refreshPage: true,
      };
    },
  },
});

export const { emptyAllReportedUserList } = allReportedUserListSlice.actions;
export default allReportedUserListSlice.reducer;
